/*
 * @Author: Roger
 * @Date: 2021-01-29 14:56:23
 * @Last Modified by: yangfanliu
 * @Last Modified time: 2022-03-22 11:52:13
 * @Description: {}
 */
<template>
  <div id="zp-main">
    <content-title :showBack="true" title="投稿信息"></content-title>
    <!-- v-if="Object.keys(planInfo).length > 0" -->
    <div class="zp-wrapper">
      <div class="zp-header">
        <div class="zp-group">
          <div class="zp-item">
            <div class="zp-item__title">参与的企划：</div>
            <div class="zp-item__main">{{ planInfo.planning_title }}</div>
          </div>
          <div class="zp-item">
            <div class="zp-item__title">企划发布者：</div>
            <div class="zp-item__main">
              <template v-if="planInfo.avatar || planInfo.username">
                <img
                  class="zp-item__avatar"
                  v-if="planInfo.avatar"
                  :src="`${constv.QINIU_IMAGE_CND_URL}${planInfo.avatar}`"
                  :alt="planInfo.username"
                />
                <span class="zp-item__nickname" v-if="planInfo.username">{{ planInfo.username }}</span>
              </template>
            </div>
          </div>
          <div class="zp-item">
            <div class="zp-item__title">投稿作品名：</div>
            <div class="zp-item__main">{{ planInfo.title }}</div>
          </div>
          <div class="zp-item">
            <div class="zp-item__title">作品类型：</div>
            <div class="zp-item__main">{{ categoryMap[planInfo.category] }}</div>
          </div>
          <div class="zp-item">
            <div class="zp-item__title">投稿时间：</div>
            <div class="zp-item__main">{{ planInfo.gmt_create }}</div>
          </div>
          <div class="zp-item" v-if="planInfo.status !== 0">
            <div class="zp-item__title">当前状态：</div>
            <div class="zp-item__main status-step">
              <span class="status-step__1" v-if="planInfo.status === 1">待评选</span>
              <span class="status-step__2" v-if="planInfo.status === 2">评选中</span>
              <span class="status-step__3" v-if="planInfo.status === 3 && planInfo.is_choice === 1">投稿获选</span>
              <span class="status-step__4" v-if="planInfo.status === 3 && planInfo.is_choice === 0">投稿落选</span>
            </div>
          </div>
        </div>
        <router-link
          :to="{ name: 'planDetail', params: { id: planInfo.planning_id } }"
          target="_blank"
          class="zp-action"
          >查看企划</router-link
        >
      </div>
      <p class="zp-line"></p>
      <div class="zp-card">
        <div class="zp-card__header">投稿的内容</div>
        <div class="zp-card__items">
          <div
            class="zp-card__item"
            :style="{ margin: planInfo.category === 3 ? '0 15px 24px' : '0 15px 28px' }"
            v-for="(item, index) in planInfo.list"
            :key="index"
          >
            <div class="zp-card__checkbox" v-if="planInfo.category === 3">
              <a-checkbox v-model="item.checked">显示信息框位置</a-checkbox>
            </div>
            <div
              class="zp-card__cover"
              :class="{ 'show-card': item.checked, 'is-card': planInfo.category === 3 }"
              :style="`background-image: url(${
                planInfo.category === 3 ? constv.QINIU_IMAGE_QNC_CDN_URL : constv.QINIU_IMAGE_CND_URL
              }${item.image})`"
            >
              <!-- TIP：人设背景与场景贴图资源路径不一样 -->
              <!-- <img :src="`${planInfo.category === 3 ? constv.QINIU_IMAGE_QNC_CDN_URL : constv.QINIU_IMAGE_CND_URL}${item.image}`" /> -->
              <img style="position: absolute; left: 0" v-if="item.checked" src="@/assets/img/img_card_pos.png" />
            </div>
            <div v-if="planInfo.category === 1 || planInfo.category === 2" class="zp-card__title">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import contentTitle from '@/components/Zpace/common/contentTitle'
export default {
  components: {
    contentTitle
  },
  data () {
    return {
      planInfo: {},
      categoryMap: {
        1: '场景',
        2: '贴图',
        3: '人设背景'
      },
      statusMap: {
        0: {
          text: '未开始',
          status: 'default'
        },
        1: {
          text: '进行中',
          status: 'processing'
        },
        2: {
          text: '评选中',
          status: 'success'
        },
        3: {
          text: '已结束',
          status: 'default'
        }
      }
    }
  },
  created () {
    this.getMyPlanDetail()
  },
  methods: {
    async getMyPlanDetail () {
      const params = {
        id: this.$route.params.id
      }
      const { data } = await this.$api.planning.getMyPlanDetail(params)
      this.planInfo = {
        ...data,
        list: data.list.map(item => {
          item.checked = false
          return item
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#zp-main {
  background-color: #fff;
  min-height: 580px;
  .zp-wrapper {
    padding: 31px 36px 36px;
  }
  .zp-header {
    display: flex;
    justify-content: space-between;
  }
  .zp-item {
    display: flex;
    margin-bottom: 17px;
    color: #999;
    &__avatar {
      width: 24px;
      height: 24px;
      border: 1px solid #e5e5e5;
      border-radius: 50%;
      margin-right: 8px;
    }
    &__title {
      width: 85px;
      text-align: right;
      margin-right: 10px;
    }
    &__main {
      color: #333;
      .status-step {
        font-size: 12px;
        color: #999;
        line-height: 24px;
        padding: 3px 10px;
        border: 1px solid #f2f2f2;
        border-radius: 24px;
        &__1 {
          color: #ff7401;
        }
        &__2 {
          color: #3097ec;
        }
        &__3 {
          color: #6cae4c;
        }
        &__4 {
          color: #bbbbbb;
        }
      }
    }
  }
  .zp-action {
    width: 88px;
    line-height: 28px;
    height: 28px;
    border-radius: 6px;
    background: #ff7401;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }

  .zp-line {
    margin: 7px 0 24px;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right, #e5e5e5 0%, #e5e5e5 40%, transparent 60%);
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
  .zp-card {
    padding: 19px 24px 0;
    border: 1px solid #f2f2f2;
    border-radius: 8px;
    &__header {
      margin-bottom: 20px;
      font-size: 14px;
      color: #999;
    }
    &__items {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }
    &__item {
      // margin: 0 12px 28px;
      cursor: pointer;
      &:hover {
        .zp-card__cover {
          border: 1px solid #ff7401;
        }
        .zp-card__title {
          color: #ff7401;
        }
      }
    }
    &__checkbox {
      display: block;
      margin-bottom: 24px;
      color: #999;
      font-size: 12px;
      /deep/ .ant-checkbox-checked .ant-checkbox-inner {
        background: none;
      }
      /deep/ .ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: @primary-color;
      }
    }
    &__cover {
      position: relative;
      width: 158px;
      height: 158px;
      border: 1px solid #f2f2f2;
      border-radius: 4px;
      transition: all ease 0.3s;
      overflow: hidden;

      // background-image: url(http://qnp.mindcomic.com/resources/contributeInfo_web/ipon1609987018yjqm.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      > img {
        width: 100%;
        border-radius: 4px; // 外层元素的圆角和里面的圆角的添加与否会表现程度不太一样
      }
      &.is-card {
        width: 300px;
        height: 532px;
      }
    }
    &__title {
      font-size: 14px;
      color: #999;
      margin-top: 7px;
      transition: all ease 0.3s;
    }
  }
}
</style>
